import axios from "axios";
import { Message, Spin } from 'view-ui-plus';
import { getToken, setsaToken,removeToken,clearAuth } from "@/utils/auth";
import store from '../store'

import router from '@/router'
import axiosRetry from 'axios-retry';
import { baseURL } from '@/api/config'
// create an axios instance
const service = axios.create({
    // baseURL: 'http://114.55.92.223:8081',
    // baseURL: 'http://localhost:8081',
    // baseURL: '/api',
    baseURL: baseURL,
    timeout: 3000000,  // request timeout

});

// 设置重试机制

const time = 1000
let id = null
// axiosRetry(service, {
//     retries: 3, // 最大重试次数
//     retryCondition: (error) => {
//         return error.response && error.response.status == 502; // 仅针对 502 错误重试
//     },
//     retryDelay: (retryCount) => {
//         return retryCount * 1000; // 每次重试的延迟时间
//     },
// });
// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent
        let token = getToken()
        if (token) {
            config.headers.satoken = token
            config.headers['Accept-Language'] = store.state.app.lang.split('-')[0]
        }
        config.headers.satoken = getToken() || ''
        clearTimeout(id)
        id = setTimeout(() => {
            Spin.show({
                render: (h) => {
                    return h('div', [
                        h('div', {
                            'class': 'animate',
                        }, 'Loading...')
                    ])
                }
            });
        }, time * 1000)

        return config;
    },
    error => {
        // do something with request error
        console.log(error); // for debug
        return Promise.reject(error);
    }
);

// response interceptor
service.interceptors.response.use(
    response => {
        console.log(response)
        const res = response.data;
        if (Object.prototype.toString.call(res) === "[object Object]") {

            if (res.code == 401) {
            
                clearAuth()
                setTimeout(() => {
                    try {
                        router.replace({ name: 'login', query: store.state.app.fromRouter.params || {} });
                      
                    } catch {
                        Message.error({
                            content: 'page error',
                            background: true,
                            duration: 5
                        });
                    }
                }, 100);
            }

            if (res.code == 10000 || res.code == 10001) {
                let rechargeText = ''
                if (res.msg == 'Credit balance is insufficient') {
                    rechargeText = 'Insufficient credits — upgrade your plan to unlock more.'
                } else if (res.msg == '') {
                    rechargeText = "You've reached the limit of 3 documents — time to upgrade!"
                }
              
                store.dispatch("user/set_recharge", {
                    recharge: true, rechargeText: rechargeText
                }); //提示充值
            }


            if (res.code != 200 && res.code != 401 && res.code != 10000 && res.code != 10001) {
                Message.error({
                    content: res.msg,
                    background: true,
                    duration: 5
                });

            }


        }
        clearTimeout(id)
        Spin.hide()
        return res;

    },
    error => {
        console.log("err" + error);
        // for debug
        if(error != 'CanceledError: cancel') {

            Message.error({
                content: 'Server error',
                background: true,
                duration: 5
            });
        }
        clearTimeout(id)
        Spin.hide()
        return error;
    }
);

export default service;